/**
 * Shared CBAM liability modelling inputs (Impact Estimator and Reporting).
 * Persisted on simulations and CBAM reports.
 */
export type EuaPriceQuarter = {
  value: string | null
  lowPercentage: string
  highPercentage: string
  isOfficialValueLocked?: boolean
}

/** EUA price fields for UI (drawer, price table) — numeric quarter value for inputs. */
export type EuaPriceQuarterData = {
  value: number | null
  lowPercentage: string
  highPercentage: string
  isOfficialValueLocked?: boolean
}

export type EuaPriceQuartersState = Record<'Q1' | 'Q2' | 'Q3' | 'Q4', EuaPriceQuarterData>

export type CbamModifiers = {
  cscfPercentage: string
  euaPriceQuarters: Record<'Q1' | 'Q2' | 'Q3' | 'Q4', EuaPriceQuarter>
}

const emptyQuarter = (): EuaPriceQuarter => ({
  value: null,
  lowPercentage: '',
  highPercentage: ''
})

/** Defaults when API has not persisted modifiers yet. */
export function getDefaultCbamModifiers(): CbamModifiers {
  return {
    cscfPercentage: '100',
    euaPriceQuarters: {
      Q1: emptyQuarter(),
      Q2: emptyQuarter(),
      Q3: emptyQuarter(),
      Q4: emptyQuarter()
    }
  }
}
